import { createBrowserRouter } from 'react-router-dom';
import { Layout } from './components/layout';
import { RequireAuth } from './components/require-auth';
import { Home } from './screens/home';
import { Login } from './screens/login';
import { Schedule } from './screens/schedule';
import { ScheduleConfig } from './screens/schedule-config';
import { Workouts } from './screens/workouts';
import { CreateWorkout } from './screens/create-workout';
import { TrackWorkout } from './screens/track-workout';
import { ReviewWorkout } from './screens/review-workout';
import { PlateCalculator } from './screens/plate-calculator';
import { GymProfiles } from './screens/gym-profiles';
import { Stats } from './screens/stats';
import { AICoach } from './screens/ai-coach';
import { Settings } from './screens/settings';
import { Onboarding } from './screens/onboarding';

export const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  { path: '/onboarding', element: <Onboarding /> },
  {
    path: '/',
    element: <RequireAuth />,
    children: [
      {
        element: <Layout />,
        children: [
          { index: true, element: <Home /> },
          { path: 'schedule', element: <Schedule /> },
          { path: 'workouts', element: <Workouts /> },
          { path: 'stats', element: <Stats /> },
          { path: 'ai-coach', element: <AICoach /> },
          { path: 'settings', element: <Settings /> },
          { path: 'schedule-config', element: <ScheduleConfig /> },
          { path: 'create-workout', element: <CreateWorkout /> },
          { path: 'create-workout/:id', element: <CreateWorkout /> },
          { path: 'track-workout', element: <TrackWorkout /> },
          { path: 'track-workout/:id', element: <TrackWorkout /> },
          { path: 'review-workout', element: <ReviewWorkout /> },
          { path: 'plate-calculator', element: <PlateCalculator /> },
          { path: 'gym-profiles', element: <GymProfiles /> },
        ],
      },
    ],
  },
]);
